import { Injectable, TemplateRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { UBXModal } from '../models';

@Injectable({
    providedIn: 'root'
})
export class UBXModalService {
    subject: Subject<UBXModal> = new Subject<UBXModal>();

    getModals(): Observable<any> {
        return this.subject.asObservable();
    }

    open(modal: TemplateRef<any>) {
        this.createModal(modal);
    }

    close() {
        this.subject.next();
    }

    private createModal(template: TemplateRef<any>) {
        this.subject.next({ template } as UBXModal);
    }
}
